// @ts-nocheck

import { Countdown } from "./countdown";
import { encoder } from "../../services/encoder";
import "./interfaces";
import Petition from "../../../../modules/petition"
import { dama } from "../../../.././modules/dama";


const encrypt = new encoder();
const pt = new Petition();
const dm = new dama;

declare global {
	interface Window {
		dama: any;
		datalayer: any;
		SHA256: any;
		drupalSettings: any;
		statusPermits: any
	}
}

/**
 * EXPORTS
 */

export const validation = (refTrivia: Element, trivia: Quiz, triviaClass: string): Promise<Validation> => {

	return new Promise((resolve, reject) => {

		let activePanel: HTMLElement = refTrivia.querySelector(`.${triviaClass}__panel--active`);
		let { qid: questionId } = activePanel.dataset;
		let optionList: any = activePanel.querySelectorAll("input[type=radio]");
		let checked = false;
		optionList.forEach((option: any, key: any) => {
			if (option.checked) {
				checked = true;
				let { ansid: answerId } = option.dataset;
				_saveData({ questionId, answerId }, trivia);
			}
		})
		resolve({
			state: checked,
			output: checked ? "Se ha escogido una opción" : "No se ha escogido una opción",
		});

	});
}


export const changeQuestion = (refTrivia: Element, trivia: Quiz, triviaClass: string, pathMedia: string): void => {
	let activePanel: HTMLElement = refTrivia.querySelector(`.${triviaClass}__panel--active`);
	let { nextElementSibling: nextQuestion } = activePanel;

	let headerActivePanel: HTMLElement = refTrivia.querySelector(
		`.${triviaClass}__header-panel--active`
	);
	let {
		nextElementSibling: nextHeaderQuestion
	} = headerActivePanel;

	activePanel.classList.remove("trivia__panel--active");
	headerActivePanel.classList.remove("trivia__header-panel--active");
	nextQuestion.classList.add("trivia__panel--active");

	if (nextHeaderQuestion) nextHeaderQuestion.classList.add("showing");

	if (nextQuestion && nextQuestion.classList.contains("trivia__panel")) {
		setTimeout(() => {
			nextHeaderQuestion.classList.remove("showing");
			nextHeaderQuestion.classList.add("trivia__header-panel--active");

			trivia.currentAnswer++;
		}, 300);
	} else {
		_showFinal(refTrivia, trivia, triviaClass, pathMedia, false);
	}
}


export const tryAgain = (refTrivia: Element, trivia: Quiz, triviaClass: string, pathMedia: string): void => {
	const redirectEndTrivia = (): void => {
		let activePanel: HTMLElement = refTrivia.querySelector(
			`.${triviaClass}__panel--active`
		);
		activePanel.classList.remove("trivia__panel--active");
		let headerActivePanel: HTMLElement = refTrivia.querySelector(
			`.${triviaClass}__header-panel--active`
		);
		headerActivePanel.classList.remove("trivia__header-panel--active");

		_showFinal(refTrivia, trivia, triviaClass, pathMedia, true);
	};

	Countdown.setCallFunc(redirectEndTrivia);
}


export const setAudioOptions = (refTrivia: Element, pathMedia: string): void => {
	let soundClic = document.createElement("audio");
	soundClic.src = `${window.drupalSettings.path.themeUrl}/sources/dist/audio/clic.mp3`;
	soundClic.preload = "metadata";
	soundClic.volume = 0.5;

	refTrivia.addEventListener("click", (e) => {
		let optionQuestion = e.target as HTMLElement;
		if (optionQuestion.classList.contains("form__input")) {
			soundClic.play();
			return;
		}
	});
}


/**
 * FUNCTIONS
 */

/**
 * 
 * @param question 
 * @param trivia 
 */
function _saveData(question: SummaryQuestion, trivia: Quiz): void {
	let { questionId, answerId } = question;
	trivia.responses = { ...trivia.responses, [questionId]: answerId };
}


async function _requestAxios(trivia: Quiz): Promise<any> {
	localStorage.setItem("attemp", "true");
	const timeTrivia = parseInt(document.getElementById('triviaContainer').getAttribute('data-aos-duration'))

	let summaryQuiz = {
		...trivia.responses,
		// time: trivia.usedTimeMS,
		// timeTrivia: timeTrivia * 100,		//pass second to Milliseconds
		// node: window.drupalSettings.trivia.id,
		// uid: window.drupalSettings.user.uid,
		// idTrivia: window.drupalSettings.trivia.id
		score: trivia.usedTimeMS,
		node: window.drupalSettings.trivia.id
	};
	
	const request = await pt.post("/trivia/gtm/ss", { t: encrypt.jwt(summaryQuiz) })
	return request;


}


function _displayInfo(trivia: Quiz, responseCorrect: any): void {
	let { time, correctAnswers, points } = trivia.htmlReferences;
	if (time) time.textContent = msToTime(parseInt(responseCorrect.time));
	if (points) points.textContent = responseCorrect.score.toString();
	if (correctAnswers) correctAnswers.textContent = `${responseCorrect.correct}`;
}


async function _showFinal(refTrivia: Element, trivia: Quiz, triviaClass: string, pathMedia: string, error?: boolean,) {
	let finalMessage = refTrivia.querySelector(`.${triviaClass}__panel-final`);
	let {
		nextButton
	} = trivia.htmlReferences;

	viewShow(3)

	_hideAudioBtn();

	// Oculta el contador y lo detiene
	try {
		Countdown.hideCounter();
		trivia.usedTime = Countdown.stopTimer();
		trivia.usedTimeMS = Countdown.calculateMs(trivia.usedTime);
	} catch (error) {
		// console.log("No hay ningun contador que parar.");
	}

	const playAudio = (file: string, preload: any): void => {
		let bellEffect = document.createElement("audio");
		bellEffect.src = `${window.drupalSettings.themeUrl}/sources/dist/audio/${file}`;
		bellEffect.preload = preload;
		bellEffect.play();
	};

	const showingSection = (
		playFunc: (file: string, preload: string) => void,
		audioErr?: boolean
	): void => {
		const pathName = window.location.pathname;
		setTimeout(() => {
			let audioSrc = audioErr ? "fail.mp3" : "correct.mp3";
			console.log(audioSrc)
			playFunc(audioSrc, "metadata");
		}, 100);
	};

	const request: any = await _requestAxios(trivia)
	const triviaEvent = new CustomEvent('triviaEnded')
	window.dispatchEvent(triviaEvent)

	showingSection(playAudio);
	_displayInfo(trivia, request);
}


function _hideAudioBtn() {
	let refAudioBtn = document.querySelector(".audio-container");
	if (refAudioBtn) refAudioBtn.classList.add("audio-container--hide");
}

export const viewShow = (view: number, remove: boolean = false) => {
	const views = ['welcomeTrivia', 'triviaContainer', 'finishedTrivia']
	views.forEach((elm: any, key: any) => {
		if (key + 1 !== view) {
			document.getElementById(elm).classList.add("view-hidden");
    document.getElementById(elm).classList.remove("view-showing");
				remove && document.getElementById(elm).remove()
			
		} else {			
			document.getElementById(elm).classList.remove("view-hidden"); 
    document.getElementById(elm).classList.add("view-showing");  			
		}
	})
}


export const printFinalTrivia = (user: any) => {
	dm.renderPage({
		'final-correct': user.correct,
		'final-score': user.score,
		'final-time': msToTime(parseInt(user.time))
	})
}


function msToTime(duration: any): any {
	let milliseconds: any = Math.floor((duration % 100))
		, seconds: any = Math.floor((duration / 100) % 60)
		, minutes: any = Math.floor((duration / (100 * 60)) % 60)
		, hours: any = Math.floor((duration / (100 * 60 * 60)) % 24);

	hours = (hours < 10) ? "0" + hours : hours;
	minutes = (minutes < 10) ? "0" + minutes : minutes;
	seconds = (seconds < 10) ? "0" + seconds : seconds;
	return seconds + "S:" + milliseconds+ "MS";
}